<template>
    <v-card class="ma-5" outlined>
        <v-list-item class="ma-5">
            <v-list-item-content>
                <v-list-item-title class="font-weight-bold">{{heading}}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar tile size="80">
                <img :src="logo" v-if="logo" class="img-ratio">
            </v-list-item-avatar>
        </v-list-item>


        <v-card-text>{{description}}
        </v-card-text>
        <v-list-item two-line>
            <v-list-item-content v-if="!!contact">
                <v-list-item-title>Kontakt: {{contact.name}}</v-list-item-title>
                <v-list-item-subtitle><a :href="`mailto:${contact.mail}`">{{contact.mail}}</a></v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
    </v-card>
</template>

<script>
    export default {
        name: "PartnerCard",
        props: [
            "heading",
            "description",
            "contact",
            "logo"
        ]
    }
</script>

<style scoped>
    .img-ratio {
        width: 100%;
        height: auto;
    }
</style>